import type { FC } from 'react';
import type { HexColor } from 'src/types/colors';

type Props = {
  className?: string;
  width?: number;
  height?: number;
  backgroundColor: HexColor;
};

export const ArrowIcon: FC<Props> = ({ className = 'rotate-0', backgroundColor, width = 70, height = 40 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 70 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M35 40L68.3827 0.75L0.617313 0.75L35 40Z" fill={backgroundColor} />
  </svg>
);
